import React from 'react'
import {Link} from "@mui/material";

const PrivateLogoBeat = (props) => {
    return (
        <Link href="/app">
            <img src="/assets/famtrail-logo-full-beta.svg"
                 alt="Famtrail"
                 style={props.style}
            />
        </Link>
    )
}

export default PrivateLogoBeat